// extracted by mini-css-extract-plugin
export default {"tagInputContainer":"TagsInput_tagInputContainer__8mr+K","tagInput":"TagsInput_tagInput__drviY","tagContainer":"TagsInput_tagContainer__4e3DV","tag":"TagsInput_tag__OgQpI"};